

















import Vue from 'vue';
import SvgIcon from '@/components/SvgIcon';
import Button from '@/components/Controls/Button/Button.vue';

export default Vue.extend({
    components: { SvgIcon, Button },

    props: {
        loading: Boolean,
    },
});
